import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../hooks/useCart';
import './CartPage.css';

function CartPage() {
  const navigate = useNavigate();
  const { cart, removeFromCart, updateQuantity, getCartTotal } = useCart();

  if (cart.length === 0) {
    return (
      <div className="empty-cart">
        <h2>Your cart is empty</h2>
        <p>Add some awesome products to get started!</p>
        <Link to="/" className="btn btn-primary">
          Continue Shopping
        </Link>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <h1>Shopping Cart</h1>

      <div className="cart-container">
        <div className="cart-items">
          {cart.map((item, index) => {
            const price = item.variation?.price || item.product.price;
            const itemTotal = price * item.quantity;
            const imageUrl = item.product.images?.[0] || '/placeholder.png';

            return (
              <div key={`${item.product.id}-${item.variation?.id || 'no-var'}-${index}`} className="cart-item">
                <img src={imageUrl} alt={item.product.name} className="item-image" />

                <div className="item-details">
                  <h3>{item.product.name}</h3>
                  {item.variation && (
                    <div className="item-variation">
                      <span>{item.variation.color}</span>
                      <span>•</span>
                      <span>{item.variation.size}</span>
                    </div>
                  )}
                  {item.variation?.sku && (
                    <div className="item-sku">SKU: {item.variation.sku}</div>
                  )}
                </div>

                <div className="item-quantity">
                  <button
                    onClick={() => updateQuantity(item.product.id, item.variation?.id, item.quantity - 1)}
                  >
                    −
                  </button>
                  <span>{item.quantity}</span>
                  <button
                    onClick={() => updateQuantity(item.product.id, item.variation?.id, item.quantity + 1)}
                  >
                    +
                  </button>
                </div>

                <div className="item-price">
                  <span className="price">${itemTotal.toFixed(2)}</span>
                  <span className="unit-price">${price.toFixed(2)} each</span>
                </div>

                <button
                  className="remove-btn"
                  onClick={() => removeFromCart(item.product.id, item.variation?.id)}
                >
                  ×
                </button>
              </div>
            );
          })}
        </div>

        <div className="cart-summary">
          <h2>Order Summary</h2>

          <div className="summary-row">
            <span>Subtotal:</span>
            <span>${getCartTotal().toFixed(2)}</span>
          </div>

          <div className="summary-row">
            <span>Shipping:</span>
            <span>Calculated at checkout</span>
          </div>

          <div className="summary-row total">
            <span>Total:</span>
            <span>${getCartTotal().toFixed(2)}</span>
          </div>

          <button
            className="btn btn-primary btn-block"
            onClick={() => navigate('/checkout')}
          >
            Proceed to Checkout
          </button>

          <Link to="/" className="continue-shopping">
            ← Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
}

export default CartPage;
